export default "__VITE_ASSET__1ixDNPiu__"